<template>
  <div class="container">
    <van-list
      v-model="dataList.loading"
      :finished="dataList.finished"
      finished-text="没有更多了"
      @load="Search"
    >
      <van-cell
        class="cell no-border-cell"
        v-for="v in dataList.list"
        :key="v.id"
      >
        <div slot="title" class="title">
          <van-image round v-if="v.headimgurl" :src="v.headimgurl"></van-image>
          <van-image round v-else src="https://maquejike.oss-cn-zhangjiakou.aliyuncs.com/static/images/icon/h.png"></van-image>
          <p>
            <span class="text-bold">{{ v.realname.slice(0,1) + '**' }}</span>
            <span class="grey">
              {{ v.mobile | phoneFilter }}
              <em>{{ v.carNo | carNoFilter }}</em>
            </span>
          </p>
        </div>
        <div class="value">{{ v.payTime }}</div>
      </van-cell>
    </van-list>
    <!-- <div v-if="res.joinUserList.length > 0">
      <van-cell class="cell no-border-cell" v-for="v in res.joinUserList" :key="v.id">
        <div slot="title" class="title">
          <van-image round :src="v.headimgurl"></van-image>
          <p>
            <span class="text-bold">{{v.nickname}}</span>
            <span class="grey">{{v.mobile|phoneFilter}}</span>
          </p>
        </div>
        <div class="value">{{v.gmtCreate}}</div>
      </van-cell>
    </div>
    <div v-if="res.joinUserList.length === 0" class="notcot">
      <div class="ntbox">
        <img :src="require('@/assets/images/icon/enpty.png')" />
        <br />
        <span>还没有记录哦~</span>
      </div>
    </div>-->
    <!-- </van-list> -->
  </div>
</template>

<script>
export default {
  name: "HasPart",

  data () {
    return {
      dataList: {
        current: 1,
        size: 10,
        list: [],
        empty: 0,
        finished: false,
        loading: false // 异步加载状态
      },
      res: {
        joinUserList: []
      }
    };
  },
  mounted () {
    // this.getDetail();
  },
  filters: {
    // 隐性显示车牌号
    carNoFilter (val) {
      if (!val) {
        return "****";
      }
      return val.substr(0, 2) + "***" + val.substr(5);
    }
  },
  methods: {
    // 获取数据
    async Search () {
      try {
        let query = this.getQuery(this);

        let pageJson = {
          page: this.dataList.current,
          limit: this.dataList.size,
          id: query.id
        };
        let result = await this.request("/activity/activity/userActivityList", {
          ...pageJson
        });
        //   console.log(result);
        //   if (result.code === 0) {
        if (this.dataList.current === 1) this.dataList.list = result.List;
        else this.dataList.list = [...this.dataList.list, ...result.List];
        this.$nextTick(() => {
          if (result.List.length < result.TotalCount) {
            this.dataList.current++;
          }
          this.dataList.loading = false;
          // 数据全部加载完成
          if (this.dataList.list.length >= result.TotalCount) {
            this.dataList.finished = true;
          }
          console.log(this.dataList);
        });
      } catch (e) {
        this.dataList.loading = false;
        this.dataList.finished = true;
        this.$error(e.message);
      }
      //   }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.ntbox {
  padding-top: 50%;
  color: #bbbbbb;
}
.notcot {
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  text-align: center;
}
.container {
  .no-border-cell {
    background: #fff;
  }
  .van-cell {
    align-items: center;
  }
  @{deep} .van-cell__value {
    flex: none;
  }
  .title {
    .flex-center();
    justify-content: flex-start;
    .van-image {
      .wh(40px, 40px);
    }
    p {
      margin-left: 5px;
      span {
        display: block;
        &.grey {
          color: #898989;
        }
        em {
          font-size: 12px;
          font-style: normal;
        }
      }
    }
  }
}
</style>